<template>
  <div>
    <b-alert
      :show="getNotification.show"
      :variant="getNotification.type"
      dismissible
      class="alert alert-elevate"
      @dismissed="notificationDismissed"
      @dismiss-count-down="countDownNotification"
      >{{ getNotification.message }}</b-alert
    >

    <div class="row">
      <div class="col-md-12">
        <MPortlet
          v-bind="{
            title: 'Permissions',
            isLoading: isLoading,
            loadingText: loadingMessage
          }"
        >
          <template v-slot:toolbar>
            <router-link
              :to="{ name: 'admin-permissions' }"
              class="btn btn-label-success btn-sm btn-bold"
              >Back</router-link
            >
          </template>
          <template v-slot:body>
            <v-card :flat="true">
              <ValidationObserver
                ref="dataForm"
                v-slot="{ valid, dirty, passes }"
              >
                <v-form @submit.prevent="passes(submit)">
                  <v-container>
                    <v-row dense>
                      <v-col cols="6" sm="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Name"
                          vid="name"
                          rules="required"
                        >
                          <v-text-field
                            v-model="formData.name"
                            :error-messages="errors"
                            label="Name"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="6" sm="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Display Name"
                          vid="display_name"
                          rules="required"
                        >
                          <v-text-field
                            v-model="formData.display_name"
                            :error-messages="errors"
                            label="Display Name"
                            required
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3" sm="6">
                        <v-row>
                          <v-col cols="6">
                            <b-button
                              variant="primary"
                              class="btn-block"
                              @click="submit"
                              :disabled="!valid"
                              >Save</b-button
                            >
                          </v-col>
                          <v-col cols="6">
                            <b-button
                              variant="danger"
                              class="btn-block"
                              @click="cancel(dirty)"
                              >Cancel</b-button
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </ValidationObserver>
            </v-card>
          </template>
        </MPortlet>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { required } from "vee-validate/dist/rules";

import { ALERT_TYPES } from "@/consts";

import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import MPortlet from "@/views/partials/content/MPortlet.vue";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty"
});

export default {
  name: "PermissionForm",
  components: {
    MPortlet,
    ValidationProvider,
    ValidationObserver
  },
  metaInfo: vm => {
    return {
      title: vm.pageTitle
    };
  },
  data() {
    return {
      recordID: null,
      storeNamespace: "adminPermissions",
      permissions: {
        list: [],
        grouped: []
      },
      formData: {
        name: "",
        display_name: "",
        permissions: []
      }
    };
  },
  beforeMount() {
    if (!this.$auth().can("add-permissions")) {
      return this.$router.replace({ name: "admin-403" });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.recordID = this.$route.params.id;
    }

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Permissions", route: "permissions" },
      { title: this.pageTitle }
    ]);

    this.loadPermissions();

    if (this.recordID > 0) {
      if (this.getActiveRecord && this.getActiveRecord.id) {
        this.initEdit(
          this.getActiveRecord,
          this.getActiveRecord.permissions || []
        );
      } else {
        this.setLoading(true);

        this.$store
          .dispatch(this.addNamespace("getRecord"), this.recordID)
          .then(response => {
            this.initEdit(response.data, response.data.permissions || []);
          })
          .catch(() => {
            this.$router.push({ name: "admin-404" });
          })
          .then(() => {
            this.setLoading(false);
          });
      }
    }
  },
  computed: {
    ...mapGetters("adminPermissions", [
      "isLoading",
      "getErrors",
      "getActiveRecord"
    ]),
    getNotification: {
      get() {
        return this.notification;
      },
      deep: true
    },
    pageTitle() {
      return `${this.isEdit ? "Edit" : "New"} Permission`;
    }
  },
  methods: {
    loadPermissions() {
      let self = this;

      this.setLoading(true, "loading permissions...");

      ApiService.query("admin/permissions", { per_page: "all" })
        .then(function(response) {
          self.permissions.list = response.data.data;
          const gObj = self.groupArray("table_name")(response.data.data);
          const props = Object.keys(gObj);
          self.permissions.grouped = [];

          props.forEach(element => {
            self.permissions.grouped.push({
              key: element,
              value: gObj[element]
            });
          });
        })
        .catch(function(error) {
          self.showNotification(error.message, ALERT_TYPES.danger, false, 5);
        })
        .then(function() {
          self.setLoading(false);
        });
    },
    groupArray(key) {
      return arrayData => {
        return arrayData.reduce((objectsByKeyValue, obj) => {
          const value = obj[key];
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(
            obj
          );
          return objectsByKeyValue;
        }, {});
      };
    },
    getItemIndex(item) {
      return this.permissions.list.findIndex(value => item.id === value.id);
    },
    submit() {
      // var formData = new FormData();
      var self = this;

      this.setLoading(true, "Saving...");

      var recordAction =
        this.recordID > 0
          ? this.$store.dispatch(this.addNamespace("updateRecord"), {
              form_data: this.formData,
              recordId: this.recordID
            })
          : this.$store.dispatch(this.addNamespace("addRecord"), {
              form_data: this.formData,
              commitData: false
            });

      recordAction
        .then(response => {
          if (response.success) {
            this.$alert({
              title: "Success!",
              message: response.message
            }).$on("confirmed", () => {
              self.$router.push({ name: "admin-permissions" });
            });

            // self.showNotification(
            //   response.message,
            //   ALERT_TYPES.Success,
            //   false,
            //   3,
            //   function() {
            //     self.$router.push({ name: "admin-permissions" });
            //   }
            // );
          }
        })
        .catch(error => {
          self.$scrollToTop();

          if (error.data && error.data.errors) {
            self.$refs.dataForm.setErrors(error.data.errors);
          } else {
            self.showNotification(
              "Operation Error! please check your input and try again",
              ALERT_TYPES.Danger,
              false,
              5
            );
          }
        })
        .then(() => {
          this.setLoading(false);
        });
    },
    cancel(isDirty) {
      if (
        isDirty &&
        !confirm("Your input will lost, do you want to continue?")
      ) {
        return;
      }

      this.formData.name = "";
      this.formData.display_name = "";
      this.$refs.dataForm.reset();

      this.$router.push({ name: "admin-permissions" });
    },
    initEdit(record, permissions) {
      this.formData.name = record.name;
      this.formData.display_name = record.display_name;

      if (permissions.length) {
        permissions.map(rPerm => {
          this.formData.permissions.push(rPerm.id);
        });
      }
    }
  }
};
</script>
